<template>
  <a
    :class="className"
    @click.prevent="blogDownloadForm"
    :href="link"
    :data-form-title="title"
    :data-form-image="image"
    :data-form-description="description"
    :data-form-id="id"
  >
    <slot></slot>
  </a>
</template>

<script setup>
import { nextTick } from 'vue'
import useGlobalStore from './../../store/globalStore'

const globalStore = useGlobalStore()
const props = defineProps({
  link: String,
  title: String,
  image: String,
  description: String,
  id: String,
  className: String,
})

const blogDownloadForm = async (e) => {
  if (e.target.tagName === 'A') {
    globalStore.setModal({name: 'rcDownloadEmail', title: e.target.dataset.formTitle, customField: props.link})
    await nextTick()
    document.getElementById('rc-download-description').innerText = props.description;
    document.getElementById('rc-download-image').src = props.image;
    // document.getElementById('rc-download-image').alt = e.target.dataset.formTitle;
    // document.getElementById('rc-download-form')
    //   .setAttribute('data-file-download-link', e.target.href);
    // document.getElementById('rc-download-id').value = e.target.dataset.formId;
  } else {
    const ele = e.target.closest('a');
    ele.click();
  }
}

</script>
